import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'

var userDataSelector = '#current-user-data';

// Set proper headers for ajax requests
$.ajaxSetup({
  'beforeSend': function(xhr) {
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
  }
});

var SophiaNS = window.SOPHIA = $.SOPHIA = {
  loggedIn: function() {
    return !!this.currentUserId();
  },

  currentUserId: function() {
    return $(userDataSelector).data('id');
  },

  currentUserSlug: function() {
    return $(userDataSelector).data('slug');
  }
};

_.extend(SophiaNS, Backbone.Events);
